import withAemIntegration from "../../withAemIntegration";

import loadable from "../../utils/loadable";
const Component = loadable(() =>
  import("@lexus.com/ui/dist/modules/ChargingMap")
);

const ChargingMapEditConfig = {
  emptyLabel: "Charging Map",
  isEmpty: function (props) {
    return !props || !props.title || props.title.trim().length < 1;
  },
};


const ChargingMap = (props) => {
  const defaultImage = "https://www.lexus.com/content/dam/lexus/images/fpo/Lexus-electrified-map-still-1920x1080-LEX-STK-CY24-0009.01.jpg";
  let { mapPlaceholderImage } = props;

  // TODO: we can update the charging map to take the full responsive image object in the future, but as we only expect one image right now, it's unnecessary.
  if (!mapPlaceholderImage || typeof mapPlaceholderImage !== 'object') {
    mapPlaceholderImage = defaultImage;
  } else {
    const singleImageFromSet = mapPlaceholderImage?.image?.desktop?.src || mapPlaceholderImage?.image?.tablet?.src || mapPlaceholderImage?.image?.mobile?.src;
    mapPlaceholderImage = singleImageFromSet || defaultImage;
  }

  return (
    <>
      <Component
        {...props} 
        mapPlaceholderImage={mapPlaceholderImage}
        height={window && window.CQ ? "800px" : undefined}
      />
    </>
  );
};

export default withAemIntegration("lexus/components/charging-map")(
  ChargingMap,
  ChargingMapEditConfig
);
